import utils from 'utils'
class popUpEmployeCtrl {
  constructor($scope, $uibModalInstance, httpRequest, modalParams, logger) {
    //输入查询
    $scope.searchValue = function (val, index) {
      $scope.index = index
      modalParams.fale = true
      $scope.searchVal = val
      // if ($scope.modalDetailsList.length < 0) {
      //   logger.logError("暂无匹配数据");
      // }
    }
    // 所选的数据
    $scope.selectedUserInfo = []
    $scope.selectedItem = null; 
    $scope.init = function () {
      $scope.modalDetailsList = modalParams.info
      $scope.type = modalParams.type
    }
    $scope.$watch('searchVal', () => {
      $scope.init()
      if (modalParams.fale) {
        let searchNameList = []
        angular.forEach($scope.modalDetailsList, function (item, index, array) {
          if (
            $scope.index == 0 &&
            item.userName.indexOf($scope.searchVal) > -1
          ) {
            searchNameList.push(item)
          } else if (
            $scope.index == 1 &&
            item.realName.indexOf($scope.searchVal) > -1
          ) {
            searchNameList.push(item)
          }
        })
        if (searchNameList.length == 0) {
          $scope.modalDetailsList = []
          logger.logError('暂无匹配数据')
        } else {
          $scope.modalDetailsList = searchNameList
        }
      }
    })
    $scope.toggleSelection = function(item) {
        $scope.selectedUserInfo.length = 0
        if ($scope.selectedItem === item) {
          $scope.selectedItem = null; // 如果已选中该行,则取消选中
        } else {
          $scope.selectedItem = item; // 否则,选中该行
          $scope.selectedUserInfo.push(item)
        }
      };
    // 保存
    $scope.save = function () {
      if (!$scope.selectedUserInfo.length)
        return logger.logError(`未选择信息！`)
      $uibModalInstance.close($scope.selectedUserInfo)
    }
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
}
popUpEmployeCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'httpRequest',
  'modalParams',
  'logger',
]
export default popUpEmployeCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/popUpEmployeCtrl.js